import { BookOpenCheckIcon, CalculatorIcon, ClipboardCheckIcon, GitForkIcon, ShieldAlertIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'HVAC Formulas & Unit Conversions Handbook',
    description: 'The formulas and conversions you use every day, in one quick reference.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Refrigeration Troubleshooting Flowcharts',
    description: 'Step-by-step decision trees for the most common system faults.',
    icon: GitForkIcon,
  },
  {
    number: '3',
    title: 'HVAC Preventive Maintenance Checklists',
    description: 'Ready-to-use checklists for splits, VRF, rooftops, AHUs, chillers and cold rooms.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '4',
    title: 'Refrigerant Handling & Safety Guide',
    description: 'Safety classes, recovery, leak detection, A2L and A3 refrigerants and safe work practices.',
    icon: ShieldAlertIcon,
  },
  {
    number: '5',
    title: 'HVAC&R Technical Glossary',
    description: 'Clear A–Z definitions and the abbreviations you hear on every job.',
    icon: BookOpenCheckIcon,
  },
];
